/* Menu open and close */
const mobileMenuOpen = document.querySelector('.js-mobileMenuOpen');
const mobileMenuClose = document.querySelector('.js-mobileMenuClose');
const mobileMenu = document.querySelector('.js-mobileMenu');
const dropdownBack = document.querySelector('.js-mobileMenuBack');
const dropdownLinks = [...document.querySelectorAll('.js-mobileMenuDropdownLink')];
const dropdownMenus = [...document.querySelectorAll('.js-mobileMenuDropdown')];
const body = document.querySelector('body');

mobileMenuOpen.addEventListener('click', () => {
    mobileMenu.classList.add('-opened');
    body.classList.add('-scrollLock');
});
mobileMenuClose.addEventListener('click', () => {
    mobileMenu.classList.remove('-opened');
    dropdownBack.classList.remove('-opened');
    dropdownMenus.forEach(dropdown => {
        dropdown.classList.remove('-opened');
    });
    body.classList.remove('-scrollLock');
});

/* Dropdown Mobile Navigation */

dropdownLinks.forEach(link => {
    link.addEventListener('click', e => {
        e.preventDefault();

        let currentWidth = window.outerWidth;

        if (currentWidth <= 1024) {
            let dataMenu = link.getAttribute('data-menu');

            dropdownMenus.forEach(dropdown => {
                let dataDropdown = dropdown.getAttribute('data-menu-dropdown');

                if (dataMenu === dataDropdown) {
                    dropdown.classList.add('-opened');
                    dropdownBack.classList.add('-opened');
                } else {
                    dropdown.classList.remove('-opened');
                }
            });
        } else {
            let aTarget = link.getAttribute('href');
            location.href = aTarget;
        }
    });
}); 

dropdownBack.addEventListener('click', () => {
    dropdownBack.classList.remove('-opened');
    dropdownMenus.forEach(dropdown => {
        dropdown.classList.remove('-opened');
    });
});

